import React from 'react';

export function ArrowWaterUp() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="60" fill="none" viewBox="0 0 30 84">
      <path
        fill="#000000"
        d="M16.414.586a2 2 0 00-2.828 0L.858 13.314a2 2 0 102.828 2.828L15 4.828l11.314 11.314a2 2 0 102.828-2.828L16.414.586zM13 82a2 2 0 104 0h-4zm0-80v80h4V2h-4z"
      />
    </svg>
  );
}
